import _ from 'lodash'
import React, { Component } from 'react'
import { Collapse, Grid, Cell, Tab, Tabs, TabsContainer } from 'react-md'
import { connect } from 'react-redux'

import { ThumbnailImage } from 'components'
import { ArtworkStatic } from 'api'
import { UploadStatus } from 'api/enums'

import * as actions from 'redux/actions'

import BasicInfoView from '../BasicInfoView'
import CommissionsView from '../CommissionsView'
import ReplicateMarkupsDialog from './ReplicateMarkupsDialog'
import ReplicateMarkupsNoteDialog from './ReplicateMarkupsNoteDialog'
import './index.css'

class ViewContent extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeTab: 0,
      isReplicateMarkupsDialogVisible: false,
      isReplicateMarkupsNoteDialogVisible: false,
      replicateMarkupsFrameType: -1
    }

    this.getThumbnailImage = this.getThumbnailImage.bind(this)
    this.getArtworkStatus = this.getArtworkStatus.bind(this)
    this.getIsReadOnly = this.getIsReadOnly.bind(this)
    this.handleTabChange = this.handleTabChange.bind(this)

    this.onShowReplicateMarkupsDialog =
      this.onShowReplicateMarkupsDialog.bind(this)
    this.onHideReplicateMarkupsDialog =
      this.onHideReplicateMarkupsDialog.bind(this)
    this.onShowReplicateMarkupsNoteDialog =
      this.onShowReplicateMarkupsNoteDialog.bind(this)
    this.onHideReplicateMarkupsNoteDialog =
      this.onHideReplicateMarkupsNoteDialog.bind(this)
    this.onReplicateMarkups = this.onReplicateMarkups.bind(this)
  }

  getThumbnailImage () {
    const { artwork } = this.props

    if (artwork.fileName) {
      return ArtworkStatic.getImageURL(artwork.id)
    }

    return null
  }

  getArtworkStatus () {
    const { artwork, isUploading, uploadStatus, uploadProgress } = this.props

    let status = artwork.status

    if (isUploading && uploadStatus && uploadStatus !== UploadStatus.DONE) {
      status = uploadStatus

      if (status === UploadStatus.UPLOADING && uploadProgress === 100) {
        status = 'PROCESSING'
      }
    }

    return status
  }

  getIsReadOnly () {
    const { artwork } = this.props
    return artwork.status !== 'DRAFT'
  }

  handleTabChange (newTabIndex) {
    this.setState({
      activeTab: newTabIndex
    })
  }

  /**
   * Displays the replicates markup dialog.
   */
  onShowReplicateMarkupsDialog (frameType) {
    this.setState({
      isReplicateMarkupsDialogVisible: true,
      replicateMarkupsFrameType: frameType
    })
  }

  /**
   * Hides the replicates markup dialog.
   */
  onHideReplicateMarkupsDialog () {
    this.setState({
      isReplicateMarkupsDialogVisible: false,
      replicateMarkupsFrameType: -1
    })
  }

  /**
   * Displays the replicates markup note dialog.
   */
  onShowReplicateMarkupsNoteDialog (frameType) {
    this.setState({
      isReplicateMarkupsNoteDialogVisible: true,
      replicateMarkupsFrameType: frameType
    })
  }

  /**
   * Hides the replicates markup note dialog.
   */
  onHideReplicateMarkupsNoteDialog () {
    this.setState({
      isReplicateMarkupsNoteDialogVisible: false,
      replicateMarkupsFrameType: -1
    })
  }

  /**
   * Replicate commission markups to all products of given frame type.
   */
  async onReplicateMarkups () {
    const { artwork, replicateMarkups } = this.props
    const { replicateMarkupsFrameType } = this.state

    await replicateMarkups(artwork.id, replicateMarkupsFrameType)

    this.onHideReplicateMarkupsDialog()
  }

  render () {
    const {
      artwork,
      form,
      isUploading,
      isEditing,
      uploadStatus,
      uploadProgress
    } = this.props

    const { activeTab, replicateMarkupsFrameType } = this.state

    const readOnly = this.getIsReadOnly()
    const artworkImage = this.getThumbnailImage()
    const artworkStatus = this.getArtworkStatus()

    return (
      <div>

        <ReplicateMarkupsDialog
          visible={this.state.isReplicateMarkupsDialogVisible}
          onCancel={this.onHideReplicateMarkupsDialog}
          onConfirm={this.onReplicateMarkups}
          frameType={replicateMarkupsFrameType}
        />

        <ReplicateMarkupsNoteDialog
          visible={this.state.isReplicateMarkupsNoteDialogVisible}
          onCancel={this.onHideReplicateMarkupsNoteDialog}
          onConfirm={this.onHideReplicateMarkupsNoteDialog}
          frameType={replicateMarkupsFrameType}
        />

        <Grid className='artwork-view'>

          <Cell desktopSize={2} size={12} align='top' className='artwork-image'>

            <ThumbnailImage
              image={artworkImage}
              status={uploadStatus}
              progress={uploadProgress}
            />

            <div className='status'>
              <div className='md-caption'>
                Artwork status
              </div>
              <span className='md-body-1'>
                {artworkStatus}
              </span>
            </div>

            <div className='artwork-tip'>
              <div className='md-caption'>
                Tip: To edit titles, tags and commissions, first you must Unpublish
                your artwork. Don't forget to Republish once your edits are
                complete.
              </div>
            </div>

          </Cell>

          { isUploading && !isEditing && (
            <Cell desktopSize={10} size={12}>
              <span className='md-caption'>
                Name
              </span>
              <div className='md-subheading-1'>
                { artwork.name }
              </div>
            </Cell>
          ) }

          <Collapse collapsed={!!isUploading && !isEditing} animate={false}>

            <Cell desktopSize={10} size={12} className='content'>
              <TabsContainer
                slideHeightProp='height'
                onTabChange={this.handleTabChange}
              >

                <Tabs tabId='artwork' className='artwork-tabs'>

                  <Tab label='Basic info'>
                    <BasicInfoView
                      initialValues={
                        _.omit(artwork, ['fileName', 'artwork', 'status'])
                      }
                      readOnly={readOnly}
                      form={form}
                    />
                  </Tab>

                  <Tab label='Commissions'>
                    <CommissionsView
                      readOnly={readOnly}
                      form={form}
                      visible={activeTab === 1}
                      onShowReplicateMarkupsDialog={
                        this.onShowReplicateMarkupsDialog
                      }
                      onShowReplicateMarkupsNoteDialog={
                        this.onShowReplicateMarkupsNoteDialog
                      }
                    />
                  </Tab>

                </Tabs>

              </TabsContainer>
            </Cell>

          </Collapse>

        </Grid>

      </div>
    )
  }
}

export default connect(null, actions)(ViewContent)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/ViewContent/index.js